@if (tailoringConditions) {
	<article>
		<ul class="list dense">
			@for (entry of tailoringConditions | mergeConditions; track entry) {
				<li class="list-item">
					<div class="query">
						@if (entry.breadcrumb) {
							<h6>{{ entry.breadcrumb }}</h6>
						}
						<h4>{{ entry.query.name }}</h4>
						<ul class="list dense">
							@for (answer of entry.query.answers; track answer) {
								<li class="answer">
									@if (answer.allowedOperations.ACCESS_TAILORING_RESOURCES) {
										<a [routerLink]="['../../../management/tailoring/' + answer.identity]">
											<h4>{{ answer.name }}</h4>
										</a>
									}
									@if (!answer.allowedOperations.ACCESS_TAILORING_RESOURCES) {
										<h4>{{ answer.name }}</h4>
									}
									@for (type of answer.conditionTypes; track type) {
										<p class="subtypes" translate="management.tailoring.answer.{{ type }}"><!--remove span--></p>
									}
								</li>
							}
						</ul>
					</div>
				</li>
			}
		</ul>
	</article>
} @else {
	@if (translateNone) {
		<article>
			<p class="empty" [translate]="translateNone"></p>
		</article>
	}
}
